/**
 * One-time cleanup of leftover Auth0 SDK state from browsers that had a session
 * before the Authentik cutover. Without this, the (now-removed) Auth0 SDK's
 * cached tokens would either confuse our new Authentik client or, more likely
 *, show up as orphaned localStorage keys until the user clears their browser.
 *
 * Runs once per session (sessionStorage flag). Idempotent.
 */

const SESSION_FLAG = 'hai_job_legacy_cleanup_done';

// Auth0 SDK uses `@@auth0spajs@@` prefix for token storage
// (one entry per (audience, scope) combo) plus a few well-known keys.
const LEGACY_KEY_PATTERNS = [
  /^@@auth0spajs@@/,           // Auth0 SPA SDK token cache
  /^auth0\./,                   // Auth0 transient state (e.g. auth0.is.authenticated)
  /^a0\.spajs\./,               // older Auth0 SPA prefix
  /^@@auth0__legacy_token__@@/, // legacy migration prefix
];

function shouldWipe(key) {
  return LEGACY_KEY_PATTERNS.some((re) => re.test(key));
}

(function runOnce() {
  if (typeof window === 'undefined') return;
  try {
    if (sessionStorage.getItem(SESSION_FLAG)) return;

    const toWipe = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && shouldWipe(key)) toWipe.push(key);
    }

    if (toWipe.length > 0) {
      // Use console.info, not warn, this is expected on first load post-cutover
      // and we don't want it shouted in support-channel screenshots.
      console.info(`[legacy-cleanup] removing ${toWipe.length} Auth0 storage key(s)`);
      for (const key of toWipe) {
        try { localStorage.removeItem(key); } catch { /* ignore */ }
      }
    }

    sessionStorage.setItem(SESSION_FLAG, '1');
  } catch (err) {
    // localStorage can throw on quota errors or in privacy modes, never fatal.
    console.warn('[legacy-cleanup] skipped:', err?.message || err);
  }
})();
